:host{position:relative}
/*# sourceMappingURL=grid-table-expanded-ng.component-WLF6HZZ3.css.map */
